module.exports = __webpack_public_path__ + "static/media/portfolioOne.4e82d3d1.png";